import { Helpers } from '@front/utils';
import { createComponent } from '@front/utils/alpine';
import { throttle } from 'lodash-es';
const Navigation = createComponent(() => ({
    isNavOpen: false,
    currentIndex: null,
    currentChildIndex: null,
    currentSubChildIndex: null,
    topBanner: document.querySelector('.js-top-banner'),
    init() {
        this.setSize();
        window.addEventListener('resize', throttle(this.setSize.bind(this), 150), { passive: true });
        this.$watch('isNavOpen', () => {
            document.body.classList.toggle('overflow-hidden', this.isNavOpen);
        });
    },
    navClose() {
        this.currentIndex = null;
        this.currentChildIndex = null;
        this.currentSubChildIndex = null;
        this.isNavOpen = false;
    },
    navToggle(index, force) {
        if (this.currentIndex == null) {
            this.currentIndex = index;
        }
        if (index == this.currentIndex) {
            this.isNavOpen = force !== undefined ? force : !this.isNavOpen;
        }
        this.currentIndex = this.isNavOpen ? index : null;
        this.currentChildIndex = null;
        this.currentSubChildIndex = null;
    },
    navToggleChild(index) {
        if (this.currentChildIndex == null) {
            this.currentChildIndex = index;
        }
        else {
            this.currentChildIndex = null;
            return;
        }
        this.currentChildIndex = this.isNavOpen ? index : null;
        this.currentSubChildIndex = null;
    },
    navToggleSubChild(index) {
        if (this.currentSubChildIndex == null) {
            this.currentSubChildIndex = index;
        }
        else {
            this.currentSubChildIndex = null;
            return;
        }
        this.currentSubChildIndex = this.isNavOpen ? index : null;
    },
    setSize() {
        if (!this.topBanner || Helpers.Screen.isWiderThanBreakpoint('md')) {
            this.$refs.sidebar.style.top = '0px';
            this.$refs.sidebar.style.height = 'auto';
        }
        else {
            this.$refs.sidebar.style.top = this.topBanner.offsetHeight + 'px';
            this.$refs.sidebar.style.height =
                'calc(100% - ' + this.topBanner.offsetHeight + 'px)';
        }
    },
}));
export { Navigation };
